var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilledRedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3795_664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5645 2.09766C14.6261 2.11225 13.7082 2.3742 12.9034 2.85705C12.0987 3.3399 11.4356 4.02655 10.9811 4.84766C10.5267 4.02655 9.86359 3.3399 9.05884 2.85705C8.2541 2.3742 7.33619 2.11225 6.39781 2.09766C4.90193 2.16265 3.49257 2.81703 2.47763 3.91785C1.4627 5.01867 0.924687 6.47643 0.981146 7.97266C0.981146 11.7618 4.96948 15.9002 8.31448 18.706C9.06133 19.3336 10.0056 19.6777 10.9811 19.6777C11.9567 19.6777 12.901 19.3336 13.6478 18.706C16.9928 15.9002 20.9811 11.7618 20.9811 7.97266C21.0376 6.47643 20.4996 5.01867 19.4847 3.91785C18.4697 2.81703 17.0604 2.16265 15.5645 2.09766Z",
    fill: "#FF4444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3795_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.98114 0.500122)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledRedIcon);
export default __webpack_public_path__ + "static/media/FilledRedIcon.7e91e30d9df4cb0461cd8f5e28759486.svg";
export { ForwardRef as ReactComponent };